// extracted by mini-css-extract-plugin
export default {"LabelContainer":"RootDomainLabel_LabelContainer__ZCalP"};